<!-- Main Navigator for the application -->

<mat-sidenav-container class="sidenav-container">

  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="false">
    <mat-toolbar color="#000">MENU</mat-toolbar>
    <div *ngIf="role === ''">
      <mat-nav-list>
        <a mat-list-item href="/signin">Home</a>
        <a mat-list-item onclick="document.getElementById('modal').style.display='block'" style="width: 80px;">Log In</a>
        <a mat-list-item href="/about">About</a>
        <a mat-list-item href="/contact">Contact</a>
        <!-- <a mat-list-item href="/land">Sign Up</a> -->
      </mat-nav-list>
    </div>
    <div *ngIf="role === 'CUSTOMER'">
      <mat-nav-list>
        <a mat-list-item href="/home">Home</a>
        <a mat-list-item href="/userprofile">Your Profile</a>
        <!-- <a mat-list-item href="/enter-banking-details">Add Banking Details</a> -->
        <a mat-list-item href="/updateprofile">Update Profile</a>
        <a mat-list-item href="/changepwd">Change Your Password</a>
        <a mat-list-item href="/get-all-tickets">Browse Tickets</a>
        <a mat-list-item href="/alloy">Create Alloy</a>
        <a mat-list-item href="/get-all-alloys">Browse Alloys</a>
        <!-- <a mat-list-item href="/get-standard-alloys">View Standard Alloys</a> -->
        <a mat-list-item href="/AcceptedT&C">Terms & Conditions</a>
        <a mat-list-item href="/view-all-graphs">Browse Curves</a>
        <a mat-list-item href="/view-scattered-plot">Explore Data</a>
        <a mat-list-item href="/get-transactions">Browse Transactions</a>
        <!-- <a mat-list-item href="/payment">Payment Gateway</a> -->

        <hr>
        <a mat-list-item [routerLink]="['/login']" (click)="logout()">Log Out</a>
      </mat-nav-list>
    </div>
    <div *ngIf="role === 'MODERATOR'">
      <mat-nav-list>
        <a mat-list-item href="/home">Home</a>
        <a mat-list-item href="/userprofile">Your Profile</a>
        <a mat-list-item href="/updateprofile">Update Profile</a>
        <!-- <a mat-list-item href="/get-un-customers">Approve Customer</a> -->
        <a mat-list-item href="/changepwd">Change Your Password</a>
        <a mat-list-item href="/create-user">Create User</a>
        <!-- <a mat-list-item href="/verify-conversation">Verify Conversation</a> -->
        <a mat-list-item href="/assign-expert">Manage Tickets</a>
        <a mat-list-item href="/add-credit">Manage Credit</a>
        <a mat-list-item href="/invoice">Customer Transactions</a>
        <a mat-list-item href="/manage-profiles">Manage Profiles</a>
        <a mat-list-item href="/get-all-transactions">View All Transactions</a>
        <!-- <a mat-list-item href="/view-latest-graph">View the Latest Graph</a>
        <a mat-list-item href="/view-all-graphs">Analyze the Graph</a> -->
        <hr>
        <a mat-list-item [routerLink]="['/login']" (click)="logout()">Log Out</a>
      </mat-nav-list>
    </div>
    <div *ngIf="role === 'TECHEXPERT'">
      <mat-nav-list>
        <a mat-list-item href="/home">Home</a>
        <a mat-list-item href="/userprofile">Profile</a>
        <a mat-list-item href="/updateprofile">Update Profile</a>
        <a mat-list-item href="/changepwd">Change Password</a>
        <a mat-list-item href="/get-assigned-tickets">Browse Tickets</a>
        <a mat-list-item href="/view-transactions">View Transactions</a>
        <!-- <a mat-list-item href="/view-latest-graph">View the Latest Graph</a>
        <a mat-list-item href="/view-all-graphs">Analyze the Graph</a> -->
        <hr>
        <a mat-list-item [routerLink]="['/login']" (click)="logout()">Log Out</a>
      </mat-nav-list>
    </div>
  </mat-sidenav>

  <mat-sidenav-content >
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"mat-drawer-inner-container ng-tns-c141-0
        mat-icon-button
        (click)="drawer.toggle()" >
        <mat-icon  aria-label="Side nav toggle icon" class="menu-toggle" >menu</mat-icon>
      </button>







      <div *ngIf="role != ''">
            <!-- style="color: white; font-style: italic; font-weight: bold; font-family: Lucida Console; font-size: xx-large; " -->
      <!-- SNAM <span style="font-size: large;">- THERMAL -->
      </div>

      &nbsp;<img style="position: absolute;" src="./assets/images/SNAM-thermal-logo.jpg" alt="SNAM-Thermal-Top-Strip" class="top-strip">


           <div class="spacer"></div>


      <div *ngIf="role === ''">
        <!--
        <button style="color: white;background-color: transparent;border: none;" onclick="document.getElementById('modal').style.display='block'">Log In</button>
        &nbsp;
        <a href = "https://snam.co.in/"  target="_blank"  >
          <b class="heading1">Our Company</b>
          </a>
          &nbsp;

          <button><b class="heading1" onclick="document.getElementById('dropdown').style.display='block';">Our Company</b></button>
            &nbsp;
        -->

            <ul class="top-level-menu">
              <li style="width: 80px;"><a onclick="document.getElementById('modal').style.display='block'">Log In</a>
              </li>
              <li><a href = "https://snam.co.in/"  target="_blank"  >
                Our Company
                </a>  </li>
              <li style="width: 90px;">
                  <a href="#">Media</a>
                  <ul style="width: 300px;padding: 5px;" class="second-level-menu">

                    <li>
                      <a style="color: rgb(0, 0, 0);text-align: left;width: 30%;padding: 10px;" href="#">Brochure</a>
                      <ul class="third-level-menu">
                          <li ><a style="color: black;font-size: medium;" href="#">Brochure 1</a></li>
                          <li><a style="color: black;" href="#">Brochure 2</a></li>
                          <li><a style="color: black;" href="#">Brochure 3</a></li>
                          <li><a style="color: black;" href="#">Brochure 4</a></li>
                      </ul>
                  </li><li>
                    <a style="color: black;text-align: left;width: 30%;padding: 10px;" href="#">Technical Article</a>
                    <ul class="third-level-menu">
                        <li><a style="color: black;" href="#">Article 1</a></li>
                        <li><a style="color: black;" href="#">Article 2</a></li>
                        <li><a style="color: black;" href="#">Article 3</a></li>
                        <li><a style="color: black;" href="#">Article 4</a></li>
                    </ul>
                </li>
         
            </ul>
          </li>

          </ul>
      </div>

      <div *ngIf="role != ''">

        <div *ngIf="role === 'CUSTOMER'">
          <button mat-button [routerLink]="['/get-transactions']"><mat-icon class="wallet-details">account_balance_wallet</mat-icon><b style="color:black;">Available Balance: {{balance}}</b></button>
          <button mat-button [matMenuTriggerFor]="menu"><mat-icon class="wallet-details">account_box</mat-icon ><b style="color:black;">{{ userDetails.fullName }}</b></button>
          <mat-menu #menu="matMenu">
            <a class="dropdown-item" [routerLink]="['/home']"><mat-icon>home</mat-icon>Home</a>
            <a class="dropdown-item" [routerLink]="['/userprofile']"><mat-icon>verified_user</mat-icon>Your Profile</a>
            <a class="dropdown-item" [routerLink]="['/AcceptedT&C']"><mat-icon>verified_user</mat-icon>Terms & Conditions</a>
            <a class="dropdown-item" [routerLink]="['/updateprofile']"><mat-icon>update</mat-icon>Update Profile</a>
            <a class="dropdown-item" [routerLink]="['/changepwd']"><mat-icon>enhanced_encryption</mat-icon>Change Your Password</a>
            <!-- <a class="dropdown-item" [routerLink]="['/raise-ticket']"><mat-icon>help</mat-icon>Request Expert Help</a> -->
            <a class="dropdown-item" [routerLink]="['/get-all-tickets']"><mat-icon>pageview</mat-icon>Browse Tickets</a>
            <a class="dropdown-item" [routerLink]="['/alloy']"><mat-icon>create</mat-icon>Create Alloy</a>
            <a class="dropdown-item" [routerLink]="['/get-all-alloys']"><mat-icon>pageview</mat-icon>Browse Alloys</a>
            <!-- <a class="dropdown-item" [routerLink]="['/get-standard-alloys']"><mat-icon>pageview</mat-icon>View Standard Alloys</a> -->
            <!-- <a class="dropdown-item" [routerLink]="['/view-latest-graph']"><mat-icon> scatter_plot</mat-icon>View Latest Curve</a> -->
            <a class="dropdown-item" [routerLink]="['/view-all-graphs']"><mat-icon> scatter_plot</mat-icon>Browse Curves</a>
            <a class="dropdown-item" [routerLink]="['/view-scattered-plot']"><mat-icon> scatter_plot</mat-icon>Explore Data</a>
            <a class="dropdown-item" [routerLink]="['/get-transactions']"><mat-icon> receipt</mat-icon>Browse Transactions</a>
            <!-- <a class="dropdown-item" [routerLink]="['/payment']"><mat-icon>payment</mat-icon>Payment Gateway</a> -->
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" [routerLink]="['/login']" (click)="logout()"><mat-icon>exit_to_app</mat-icon>Log out</a>
          </mat-menu>
        </div>

        <div *ngIf="role === 'MODERATOR'">
          <!-- <button mat-button [matMenuTriggerFor]="notificationsMenu"><mat-icon matBadge={{unverifiedMessagesCount}} matBadgeColor="warn">notifications</mat-icon></button>
          <mat-menu #notificationsMenu="matMenu" yPosition="below" xPosition="before">
            <button mat-menu-item *ngFor="let message of unverifiedMessages">
              <span matBadge={{message.unverifiedMessageCount}} matBadgeOverlap="false">{{message._id}}</span>
              <br>
              <span>{{message._id}}</span>
            </button>
          </mat-menu> -->
          <button mat-button [matMenuTriggerFor]="menu"><mat-icon>account_box</mat-icon><b style="color:black;">{{ userDetails.fullName }}</b></button>
          <mat-menu #menu="matMenu">
            <a class="dropdown-item" [routerLink]="['/home']"><mat-icon>home</mat-icon>Home</a>
            <a class="dropdown-item" [routerLink]="['/userprofile']"><mat-icon>verified_user</mat-icon>Your Profile</a>
            <a class="dropdown-item" [routerLink]="['/updateprofile']"><mat-icon>update</mat-icon>Update Profile</a>
            <!-- <a class="dropdown-item" [routerLink]="['/get-un-customers']"><mat-icon>offline_pin</mat-icon>Approve Customers</a> -->
            <a class="dropdown-item" [routerLink]="['/changepwd']"><mat-icon>enhanced_encryption</mat-icon>Change Your Password</a>
            <a class="dropdown-item" [routerLink]="['/create-user']">	<mat-icon>create</mat-icon>Create User</a>
            <!-- <a class="dropdown-item" [routerLink]="['/verify-conversation']">	<mat-icon> chat</mat-icon>Verify Conversation</a> -->
            <a class="dropdown-item" [routerLink]="['/assign-expert']"><mat-icon>assignment_ind</mat-icon>Manage Tickets</a>
            <a class="dropdown-item" [routerLink]="['/add-credit']"><mat-icon>payment</mat-icon>Manage Credit</a>
            <a class="dropdown-item" [routerLink]="['/invoice']"><mat-icon>picture_as_pdf</mat-icon>Customer Transactions</a>
            <a class="dropdown-item" [routerLink]="['/report']"><mat-icon>picture_as_pdf</mat-icon>Manage Reports</a>
            <a class="dropdown-item" [routerLink]="['/manage-profiles']">	<mat-icon>adjust</mat-icon>Manage Profiles</a>
            <a class="dropdown-item" [routerLink]="['/get-all-transactions']"><mat-icon>payment</mat-icon>View All Transactions</a>

            <!-- <a class="dropdown-item" [routerLink]="['/view-latest-graph']"><mat-icon> scatter_plot</mat-icon>View the Latest Graph</a>
            <a class="dropdown-item" [routerLink]="['/view-all-graphs']"><mat-icon> scatter_plot</mat-icon>Analyze the Graph</a> -->
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" [routerLink]="['/login']" (click)="logout()"><mat-icon>exit_to_app</mat-icon>Log out</a>
          </mat-menu>
        </div>

        <div *ngIf="role === 'TECHEXPERT'">
          <button mat-button [matMenuTriggerFor]="menu"><mat-icon>account_box</mat-icon><b style="color:black;">{{ userDetails.fullName }}</b></button>
          <mat-menu #menu="matMenu">
            <a class="dropdown-item" [routerLink]="['/home']"><mat-icon>home</mat-icon>Home</a>
            <a class="dropdown-item" [routerLink]="['/userprofile']"><mat-icon>verified_user</mat-icon>Profile</a>
            <a class="dropdown-item" [routerLink]="['/updateprofile']"><mat-icon>update</mat-icon>Update Profile</a>
            <a class="dropdown-item" [routerLink]="['/changepwd']"><mat-icon>enhanced_encryption</mat-icon>Change Password</a>
            <a class="dropdown-item" [routerLink]="['/get-assigned-tickets']"><mat-icon>reply</mat-icon>Browse Tickets</a>
            <a class="dropdown-item" [routerLink]="['/view-transactions']"><mat-icon>payment</mat-icon>View Transactions</a>
            <!-- <a class="dropdown-item" [routerLink]="['/view-latest-graph']"><mat-icon> scatter_plot</mat-icon>View the Latest Graph</a>
            <a class="dropdown-item" [routerLink]="['/view-all-graphs']"><mat-icon> scatter_plot</mat-icon>Analyze the Graph</a> -->
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" [routerLink]="['/login']" (click)="logout()"><mat-icon>exit_to_app</mat-icon>Log out</a>
          </mat-menu>
        </div>
      </div>
      <!-- <ul>
      <li class="nav-item dropdown" *ngIf="role != ''">
        <a class="nav-link" id="navbarDropdownProfile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="toggle = !toggle">
          <mat-icon>account_circle</mat-icon>
          <span>
              {{ userDetails.fullName }}
          </span>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownProfile" *ngIf="role === 'CUSTOMER' && toggle">
          <a class="dropdown-item" [routerLink]="['/home']">Home</a>
          <a class="dropdown-item" [routerLink]="['/userprofile']">Your Profile</a>
          <a class="dropdown-item" [routerLink]="['/enter-banking-details']">Add Banking Details</a>
          <a class="dropdown-item" [routerLink]="['/updateprofile']">Update Profile</a>
          <a class="dropdown-item" [routerLink]="['/changepwd']">Change Your Password</a>
          <a class="dropdown-item" [routerLink]="['/raise-ticket']">Request Expert Help</a>
          <a class="dropdown-item" [routerLink]="['/get-all-tickets']">Browse Tickets</a>
          <a class="dropdown-item" [routerLink]="['/alloy']">Create Alloy</a>
          <a class="dropdown-item" [routerLink]="['/get-all-alloys']">Browse Alloys</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" [routerLink]="['/login']" (click)="logout()">Log out</a>
        </div>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownProfile" *ngIf="role === 'MODERATOR'">
          <a class="dropdown-item" [routerLink]="['/home']">Home</a>
          <a class="dropdown-item" [routerLink]="['/userprofile']">Your Profile</a>
          <a class="dropdown-item" [routerLink]="['/updateprofile']">Update Profile</a>
          <a class="dropdown-item" [routerLink]="['/get-un-customers']">Approve Customers</a>
          <a class="dropdown-item" [routerLink]="['/changepwd']">Change Your Password</a>
          <a class="dropdown-item" [routerLink]="['/assign-expert']">Assign Expert</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" [routerLink]="['/login']" (click)="logout()">Log out</a>
        </div>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownProfile" *ngIf="role === 'TECHEXPERT'">
          <a class="dropdown-item" [routerLink]="['/home']">Home</a>
          <a class="dropdown-item" [routerLink]="['/userprofile']">Your Profile</a>
          <a class="dropdown-item" [routerLink]="['/updateprofile']">Update Profile</a>
          <a class="dropdown-item" [routerLink]="['/changepwd']">Change Your Password</a>
          <a class="dropdown-item" [routerLink]="['/get-assigned-tickets']">Assigned Tickets</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" [routerLink]="['/login']" (click)="logout()">Log out</a>
        </div>
      </li>
      </ul> -->
    </mat-toolbar>

    <!-- Add Content Here -->
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
